import adapter from '../adapters/index';
import axiosAdapter from '../adapters/axios';

/**
 * 请求分发函数 - 根据运行环境选择适配器
 *
 * @param {Object} config - 请求配置对象
 * @return {Promise} 返回请求的Promise对象
 *
 * @example
 * // 在uni-app环境中使用默认adapter
 * // 在非uni-app环境中使用axiosAdapter
 * dispatchRequest({
 *   url: '/api/data',
 *   method: 'GET'
 * });
 */
export default (config) => {
  // 更精确的uni-app环境检测
  // 检查是否真正在uni-app运行时环境中，而不仅仅是webview环境
  const isUniAppEnv =
    typeof uni !== 'undefined' && typeof uni.request === 'function';

  // 根据环境选择适配器
  return isUniAppEnv ? adapter(config) : axiosAdapter(config);
};
